import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2023ProgramaInformatico() {
  return <CategoryPage category="anexo30Y31Ano2023ProgramaInformatico" pageTitle="Programa Informatico 2023" />;
}

export default Anexo30Y31Ano2023ProgramaInformatico;
